import {
    Box,
    Button,
    Grid,
    GridItem,
    Image,
    Text,
    useDisclosure
  } from "@chakra-ui/react";
  import CandImg from "../../../../common/assets/img/userIcon.png";
  import colors from "common/theme/foundations/colors";
  import CommonCheckTable from "common/components/checktable";
  import { useState } from "react";
  import { IoIosArrowBack } from "react-icons/io";
import { constant } from "common/constant";
import { TotalApplications } from "services/Recruit/data/recruitData"; 
import { jobsData } from "services/Recruit/data/recruitData";
  
  export default function InterviewDetailsCard({ cardTitle, showCardDetails = false, showTableCard = false }) {
      let title = constant.roles;
      const [isLoading, setIsLoading] = useState(false);
      const [searchedData, setSearchedData] = useState([]);
      const { isOpen, onOpen, onClose } = useDisclosure();
      const [searchboxOutside, setSearchboxOutside] = useState("");
      const [getTagValuesOutSide, setGetTagValuesOutside] = useState([]);
      const [displaySearchData, setDisplaySearchData] = useState(false);
      
  
      const columns = [
          {
            Header: "Jobs",
            accessor: "job",
            cell: (cell) => (
                <Box>
                  <Text
                me="10px"
                fontSize="sm"
                fontWeight="700"
              >
                {cell?.value}
              </Text>
                 <Text className="totalApplocation"> {cell?.value}</Text>
                </Box>
              
            ),
          },
          { Header: "Applied", accessor: "applied",  cell: (cell) => (
            <>
            <Button className="tableBtn applied" bg={colors.black} >{cell?.value}</Button>
            </>
          ) },
          { Header: "Phone Screen", accessor: "phoneScreen" },
          { Header: "Interview", accessor: "interview" },
          { Header: "Hired", accessor: "hired",cell: (cell) => (
            <>
            <Button  className="tableBtn hired" bg={colors.green[500]} >{cell?.value}</Button>
            </>
          ) },
          { Header: "Rejected", accessor: "rejected",cell: (cell) => (
            <>
            <Button className="tableBtn rejected" bg={colors.red[600]} >{cell?.value}</Button>
            </>
          ) },
        ];
    
    return (
      <>
        <Box className="recruit-info-card ">
          <Box className="cardHeader">
            <Text className="cardTitle">{cardTitle}</Text>
          </Box>
          <Box className="cardBody">
            {showCardDetails && (
              <Box className="card-details">
                {jobsData.map((data) => (
                    <Grid
                  templateColumns="repeat(8, 1fr)"
                  gap={4}
                  alignItems={"center"}
                  className="details-row"
                >
                  <GridItem colSpan={2}>
                    <Text className="designation">{data.designation}</Text>
                  </GridItem>
                  <GridItem colSpan={2}>
                    <Text className="endDate">{data.endDate}</Text>
                  </GridItem>
                  <GridItem colSpan={3}>
                    <Box className="candidate-info" display={"flex"} gap={"12px"}>
                      <Box className="candidate-image-box">
                        <Image src={CandImg} className="candidate-image" />
                      </Box>
                      <Box display={"flex"} flexDirection={"column"}>
                        <Text className="candidate-name">{data.candidateName}</Text>
                        <Text className="experience">{data.experience}</Text>
                      </Box>
                    </Box>
                  </GridItem>
                  <GridItem colSpan={1}>
                    <Button
                      variant={"outline"}
                      size={"sm"}
                      rounded={"4px"}
                      fontSize={"12px"}
                      fontWeight={"500"}
                      color={colors.textColor}
                    >
                      {constant.view}
                    </Button>
                  </GridItem>
                </Grid>
                ))}                
              </Box>
            )}
            
            {showTableCard && (
              <Box className="table-card">
                <CommonCheckTable
                       title={title}
                       isLoading={isLoading}
                       columnData={columns}
                       dataColumn={columns}
                       allData={TotalApplications}
                       tableData={TotalApplications}
                       AdvanceSearch={() => ""}
                       tableCustomFields={[]}
                       searchedDataOut={searchedData}
                       searchDisplay={displaySearchData}
                       setSearchDisplay={setDisplaySearchData}
                       setSearchedDataOut={setSearchedData}
                       searchboxOutside={searchboxOutside}
                       setSearchboxOutside={setSearchboxOutside}
                       BackButton={
                         <Button
                           className="shape-default"                      
                           variant="brand"
                           size="sm"
                           leftIcon={<IoIosArrowBack />}
                         >
                           Back
                         </Button>
                       }
                       deleteMany={true}
                       access={true}
                       checkBox={false}
                       getTagValuesOutSide={getTagValuesOutSide}
                       setGetTagValuesOutside={setGetTagValuesOutside}
                       ManageGrid={false}
                       onOpen={onOpen}
                       isHideNavbarAction={false}
                       
                     />
              </Box>
            )}
          </Box>
        </Box>
      </>
    );
  }